import { createClient } from '@supabase/supabase-js';
import axios from 'axios';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Null client when env vars missing — auth guard treats that as "auth
// disabled" so local dev without a Supabase project still works.
export const supabase = (SUPABASE_URL && SUPABASE_ANON_KEY)
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'jvista-auth-v1',
      },
    })
  : null;

export const authEnabled = !!supabase;

// Attach the Supabase access token to every backend call. All API modules use
// the default axios singleton, so this one interceptor covers simulation, curva,
// ai, feedback, and KB requests — without it, the backend JWT gate would 401 our
// own logged-in testers. getSession() reads the cached session (refreshes only
// when near expiry), so this adds no per-request network cost in the common case.
if (supabase) {
  axios.interceptors.request.use(async (config) => {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
}
